export default {
  changestyle(state, style) {
    window.localStorage.setItem('COLOR', style);
    state.cssstyle = style
  },
  setusemessage(state, message) {
    state.usemessage = message
  },
  setmeetingcfparty(state, message) {
    state.meeting.cfparty = message
  },
  setmeetingcfhost(state, message) {
    state.meeting.cfhost = message
  },
  setmeetingcfpartyname(state, message) {
    state.meeting.cfpartyname = message
  },
  setmeetingcfhostname(state, message) {
    state.meeting.cfhostname = message
  },
  setmeetingcfterminal(state, message) {
    state.meeting.cfterminal = message
  },
  setmeetingcfterminalname(state, message) {
    state.meeting.cfterminalname = message
  },
  sethasmediasuite(state, message) {
    state.hasmediasuite = message
  },
  setserverurl(state, message) {
    state.serverurl = message
  },
  changedoubleCurrent(state, message){
    state.doubleCurrentStatus = message
  },
  changelandscape(state,message){
    state.Screenstatus=message
  },
  changeportrait(state,message){
    state.Screenstatus=message
  },
  setTrminalId(state,message){
    state.TremianlId=message
  },
  setdmaDomain(state,message){
    state.dmaDomain=message
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js